import { Farm } from '@/common/interface/farm.data.model';
import { NgModule } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FarmService } from '@services/farm.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ForecastService } from '@services/forecast.service';
import { Observable } from 'rxjs';
import { LoaderService } from '@services/loader.service';

@Component({
  selector: 'app-forecast',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './forecast.component.html',
  styleUrl: './forecast.component.scss'
})
export class ForecastComponent {
  forecastForm!: FormGroup;
  public isAuthLoading = false;
  public isLoading$: Observable<boolean>;
  public farmHouseSensorsList: any[] = [];
  forecastData: any[] = [];
  error: string | null = null;

  constructor(private farmService: FarmService, 
    private router: Router, private fb: FormBuilder, 
    private http: HttpClient, 
    private forecastService: ForecastService,
    private loaderService: LoaderService,
  ) {
    this.forecastForm = this.fb.group({
      sensor: [null], // Default value is null
    });
  }

  ngOnInit(): void {
    // Load data when the component initializes
    this.GetFarmHouseSensorsList();

  }

  getForecastList(deviceId: string = '') {
    this.loaderService.showLoader();
    this.isAuthLoading = true;
    this.forecastService.getForecastList(this.forecastForm.value.sensor).subscribe(
      result => {
        this.forecastData = result.prediction;
        this.error = result.error;
        console.log(this.forecastData);
        this.isAuthLoading = false;
        this.loaderService.hideLoader();
      }
    );
  }

  GetFarmHouseSensorsList(): void {
    this.forecastService.getFarmSensorsList().subscribe((sensors) => {
      this.farmHouseSensorsList = sensors; // Assuming the service returns an array of sensors
      console.log("bb", this.farmHouseSensorsList);
    });
  }

  onSubmit() {
    
    this.getForecastList();
  }
}
